<template>
  <div class="content">
    <div v-show="!loaded">
      <div class="lds-dual-ring"></div>
    </div>
    <div class="inner" v-show="loaded">
      <h1 class="title">
        <strong>Users</strong>
      </h1>

      <!-- <div class="actions">
        <a @click.prevent="addUser" class="btn edit-save" href> <i class="fa fa-check-square-o"></i> Add User </a>
      </div> -->

      <schema-section
        :key="section._id"
        :resetable="true"
        :page="page"
        :ref="'section' + index"
        :section="section"
        :single="schema.length == 1 ? true : false"
        @reset="resetPassword($event)"
        @delete="_delete($event)"
        @editing="editSection(section, $event)"
        @save="saveSection(section, $event)"
        v-for="(section, index) in schema"
      />

      <p class="temp" v-if="temp_password">
        User added with temporary password <strong>{{ temp_password }}</strong>
      </p>
      <p class="temp" v-if="reset_password">
        User's password reset to temporary password <strong>{{ reset_password }}</strong>
      </p>
    </div>
  </div>
</template>

<script>
import api from "@/services/api"
import cognito from "@/services/cognito"
import validate from "@/validate"

import SchemaSection from "@/components/SchemaSection.vue"

export default {
  name: "Users",
  components: { SchemaSection },
  data: function() {
    return {
      loaded: false,

      temp_password: "",
      reset_password: "",

      section: {},
      schema: [],
      page: { password: "", current_password: "", users: [] }
    }
  },
  created() {
    api.getSchema("user").then(response => {
      this.schema = JSON.parse(JSON.stringify(response)).item
      this.section = this.schema[0]
      this.$nextTick().then(() => (this.loaded = true))
    })

    api
      .getUsers()
      .then(res => (this.page.users = res))
      .catch(err => console.log(err))
  },
  methods: {
    _delete(e) {
      this.temp_password = ""
      this.reset_password = ""
      api
        .deleteUser(this.page.users[e.i])
        .then(() => this.page.users.splice(e.i, 1))
        .catch(err =>
          this.$store.dispatch({
            type: "setError",
            message: "There was an error"
          })
        )
    },
    resetPassword(e) {
      this.temp_password = ""
      this.reset_password = ""
      api
        .resetUserPassword(this.page.users[e.i])
        .then(res => {
          this.reset_password = res.password
        })
        .catch(err =>
          this.$store.dispatch({
            type: "setError",
            message: "There was an error"
          })
        )
    },
    editSection(section, e) {
      this.temp_password = ""
      this.reset_password = ""
      this.$set(section, "editing", e.editing)
      if (section.editing) {
        if (e.i == -1 && section.properties) {
          var defaults = section.properties.filter(p => p.default)
          defaults.forEach(d => (e.page[d.prop_name] = d.default))
        }

        // Set page property on section to object being edited
        this.$set(section, "page", JSON.parse(JSON.stringify(e.page)))

        // Use _id to track object being edited
        section.current_id = e.page._id

        // Use index to track if object is new
        section.current_i = e.i
      }

      // clear errors from properties
      for (var iprop = 0; iprop < section.properties.length; iprop++) {
        if (section.properties[iprop].error) section.properties[iprop].error = ""
      }
    },
    saveSection(parent, section) {
      if (!section.newvalue.sub) {
        // adding
        validate(this, section.newvalue, [parent], false).then(isValid => {
          section.newvalue.email = parent.email
          if (isValid)
            api
              .createUser(section.newvalue)
              .then(res => {
                this.temp_password = res.password
                this.page.users.push(res.user)
                this.$set(this.section, "editing", false)
              })
              .catch(err => {
                if (err && err.response && err.response.data && err.response.data.message) {
                  this.$store.dispatch({
                    type: "setError",
                    message: err.response.data.message
                  })
                } else {
                  this.$store.dispatch({
                    type: "setError",
                    message: "There was an error"
                  })
                }
              })
        })
      }
    }
  }
}
</script>
